/**
 * Fit Selector - Updates selected value display when fit option changes
 */

document.addEventListener('DOMContentLoaded', () => {
  const fitSelectors = document.querySelectorAll('.fit-selector');
  
  fitSelectors.forEach(selector => {
    const radios = selector.querySelectorAll('.fit-selector__radio');
    const selectedValue = selector.querySelector('[data-selected-fit]');
    
    if (!selectedValue) return;
    
    radios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        if (e.target.checked) {
          selectedValue.textContent = e.target.value;
        }
      });
    });
  });
});
